import { AxiosError } from 'axios';
import { DELETE_ONLINE_TUTORIALS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface OnlineTutorialsListingContent {}

export interface OnlineTutorialsListingResponse {}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: OnlineTutorialsListingResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteOnlineTutorials = ({ onSuccess, onError }: Input) => {
  const deleteOnlineTutorials = async (uuid: string) => {
    const res = await axiosClient.delete<OnlineTutorialsListingResponse>(
      DELETE_ONLINE_TUTORIALS(uuid)
    );

    return res.data;
  };

  return useCustomMutation(
    deleteOnlineTutorials,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
